module.exports = __webpack_public_path__ + "static/media/gamepedia.7a786acd.jpeg";